export default __webpack_public_path__ + "ac9bb863f42752d7263434b73756cfdf.svg";